function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("circle", {
  id: "Ellipse_131",
  "data-name": "Ellipse 131",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(159 382)",
  fill: "#fff"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_2032",
  "data-name": "Group 2032",
  transform: "translate(-230 -524)"
}, React.createElement("g", {
  id: "Ellipse_130",
  "data-name": "Ellipse 130",
  transform: "translate(230 524)",
  fill: "#fff",
  stroke: "#d4dbe2",
  strokeWidth: 1
}, React.createElement("circle", {
  cx: 29,
  cy: 29,
  r: 29,
  stroke: "none"
}), React.createElement("circle", {
  cx: 29,
  cy: 29,
  r: 28.5,
  fill: "none"
})), React.createElement("g", {
  id: "Mask_Group_9",
  "data-name": "Mask Group 9",
  transform: "translate(75 146)",
  clipPath: "url(#clip-path)"
}, React.createElement("g", {
  id: "image",
  transform: "translate(170.051 392.781)"
}, React.createElement("path", {
  id: "Path_1084",
  "data-name": "Path 1084",
  d: "M14.858,20.166,21.024,14l7.77,6.906",
  transform: "translate(-1.895 -1.504)",
  fill: "none",
  stroke: "#d4dbe3",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("path", {
  id: "Path_1085",
  "data-name": "Path 1085",
  d: "M1,23.906,8.77,17l7.339,6.258",
  transform: "translate(0 -1.914)",
  fill: "none",
  stroke: "#d4dbe3",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("rect", {
  id: "Rectangle_1830",
  "data-name": "Rectangle 1830",
  width: 26,
  height: 22,
  rx: 3,
  transform: "translate(0.949 3.223)",
  fill: "none",
  stroke: "#d4dbe3",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("circle", {
  id: "Ellipse_132",
  "data-name": "Ellipse 132",
  cx: 2,
  cy: 2,
  r: 2,
  transform: "translate(10.949 7.223)",
  fill: "none",
  stroke: "#d4dbe3",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}))));

const SvgCompanyAvatar = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCompanyAvatar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/company_avatar.03b9bc65.svg";
export { ForwardRef as ReactComponent };